import moment from "moment";
import axios from "axios";
import Vue from "vue";
import router from "./router";
import store from "./vuex";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPlay,
    faCheck,
    faTimes,
    faSignOutAlt,
    faStop,
    faBars,
    faFolder,
    faArrowLeft,
    faArrowRight,
    faPencilAlt,
    faEye,
    faUserTie,
    faPlus,
    faTrash,
    faCog,
    faLock,
    faUserSecret,
    faTag,
    faList,
    faReply
} from "@fortawesome/free-solid-svg-icons";
import {
    faClock,
    faUser,
    faTrashAlt,
    faStickyNote
} from "@fortawesome/free-regular-svg-icons";
import {
    FontAwesomeIcon,
    FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

import FloatingLabel from "./components/FloatingLabel";
import Modal from "./components/Modal";
import Toggle from "./components/Toggle";

import autofocus from "vue-autofocus-directive";
import Ripple from "vue-ripple-directive";
import Vue2TouchEvents from "vue2-touch-events";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import Multiselect from "vue-multiselect";
import VueMaterial from 'vue-material';
import vGanttChart from 'v-gantt-chart';
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { Settings } from 'luxon'

Settings.defaultLocale = 'sk';

Vue.use(vGanttChart);
Vue.use(VueMaterial);
Vue.use(Datetime);

// Vue.material.locale.dateFormat = 'dd.MM.YYYY';
Vue.material.locale.days = ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'];
Vue.material.locale.shortDays = ['Ned', 'Pon', 'Utr', 'Str', 'Štr', 'Pia', 'Sob'];
Vue.material.locale.shorterDays = ['N', 'P', 'U', 'S', 'Š', 'P', 'S'];

Vue.material.locale.months = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'];
Vue.material.locale.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'];
Vue.material.locale.shorterMonths = ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D'];

Vue.material.locale.firstDayOfAWeek = 1;

import 'vue-material/dist/vue-material.min.css'
import "./App.scss";

import { isMobile } from "./utils";

moment.locale("sk");

Ripple.color = "rgba(209,209,209, 0.35)";

window.Vue = Vue;
window.moment = moment;

axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "Access-Control-Allow-Origin": "*"
};

library.add(
    faPlay,
    faCheck,
    faTimes,
    faSignOutAlt,
    faStop,
    faBars,
    faFolder,
    faArrowLeft,
    faArrowRight,
    faPencilAlt,
    faClock,
    faEye,
    faUser,
    faUserTie,
    faPlus,
    faTrash,
    faTrashAlt,
    faCog,
    faLock,
    faUserSecret,
    faTag,
    faStickyNote,
    faList,
    faReply
);


Vue.use(Vue2TouchEvents);
Vue.use(VueAxios, axios);
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});

Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome", FontAwesomeIcon);
Vue.component("floating-label", FloatingLabel);
Vue.component("Modal", Modal);
Vue.component("toggle", Toggle);
Vue.component("multiselect", Multiselect);

Vue.directive("autofocus", autofocus);
Vue.directive("ripple", Ripple);

Vue.prototype.$isMobile = isMobile.any();
Vue.prototype.$appName = "Sixnet Intranet";
Vue.prototype.$utils = require("./utils");

Vue.config.productionTip = false;

let token = localStorage.getItem("token");
if (typeof token !== "undefined" && token !== null) {
    store.commit("setJwtToken", { jwt: { token } });
}

Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups
    }, {})
};

Vue.directive("click-outside", {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his childrens
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    }
});

import App from "./App.vue";
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
